import { Loader2 } from "lucide-react";
import { Outlet } from "react-router-dom";

import SelectTenant from "@/features/auth/components/SelectTenant";
import { useAuth } from "@/lib/hooks/useAuth";
import { useTenants } from "@/lib/hooks/useTenants";

const TenantGate = () => {
  const { role, tenantId, setTenantId } = useAuth();
  const { tenants, tenantsLoading, tenantsFetching } = useTenants();

  if (role === "SuperAdmin") {
    const tenantsLoaded = Boolean(tenants?.data);
    const stillLoading = tenantsLoading || tenantsFetching || !tenantsLoaded;

    if (stillLoading) {
      return (
        <div className="flex h-screen w-full items-center justify-center">
          <div className="flex h-full w-full items-center justify-center p-6">
            <Loader2 className="size-16 animate-spin text-muted-foreground" />
          </div>
        </div>
      );
    }

    const tenantIds = tenants!.data.map(({ id }) => id);
    const mustSelectTenant = !tenantId || !tenantIds.includes(tenantId);

    if (mustSelectTenant) {
      return <SelectTenant tenants={tenants} setTenantId={setTenantId} />;
    }
  }

  return <Outlet />;
};

export default TenantGate;
